import { useEffect, useState } from 'react'
import Table, { Column } from '../../../Components/Tables/Table';
import { useParams } from 'react-router-dom';
import { InventoryDetails, InventoryDetailsPayload, InventoryDetailsTabProps } from './model/inventoryOverview.model';
import { ApiResponse } from '../../../model/common/apiResponse';
import Loader from '../../../Components/GlobalLoader/Loader';
import { getInventoryDetails } from './service/inventoryOverview.service';
import { usePagination } from '../../../hooks/usePagination';

export const InventoryTableDetails:React.FC<InventoryDetailsTabProps> = ({
    warehouseId
}) => {
  const { id } = useParams();
  const [inventoryData, setInventoryData] = useState<ApiResponse<any> | null>(null);
  const [loading, setLoading] = useState(true);
  const { currentPage, handlePageChange, perPage } = usePagination();
  let payload = {...InventoryDetailsPayload};
 
  const Columns: Column[] = [
    {
      name: "Inv Status",
      selector: (row: InventoryDetails) => row?.status_description ? row?.status_description : '-',
    },
    {
      name: "Qty/OH",
      selector: (row: InventoryDetails) => row?.qty_on_hand ? row?.qty_on_hand : 0,
    },
    {
      name: "Qty/Alloc",
      selector: (row: InventoryDetails) => row?.qty_reserved ? row?.qty_reserved : 0,
    },
    {
      name: "Lot No.",
      selector: (row: InventoryDetails) => row?.lot_number ? row?.lot_number : 0,
    },
    {
      name: "Tag No.",
      selector: (row: InventoryDetails) => row?.tag_number ? row?.tag_number : 0,
    },
    {
      name: "Serial No.",
      selector: (row: InventoryDetails) => row?.serial_number ? row?.serial_number : '-',
    },
    {
      name: "Bin Location",
      selector: (row: InventoryDetails) => row?.name ? row?.name : '-',
    },
  ];

  useEffect(() => {
    if (id) {
      setLoading(true);
      payload.limit = perPage;
      payload.page = currentPage;
      payload.conditions = [
        ["item.id", "=", id],
        ["warehouse.id", "=", warehouseId]
    ];
      getInventoryDetails(payload).then((response) => {
        setInventoryData(response ?? null);

      }).finally(() => {
        setLoading(false);
      });
    }
  }, [id,currentPage]);
  return !loading ? (
    <div className="mb-2 mt-1 bg-white rounded px-4 py-3">
      <Table
        columns={Columns}
        data={inventoryData?.data?.results || []}
        isStripped={true}
        CheckboxStatus = {false}
        pagination={{
          recordsPerPage: perPage,
          totalRecords: inventoryData?.data?.recordsTotal,
          currentPage: currentPage,
          onCurrentPageChange: handlePageChange,
        }}
      />
    </div>

  ) : <Loader />
}
